






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import { namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import TextField from '@/components/form/TextField.vue';
import { ValidationError } from 'class-validator';
import { Validator } from 'class-validator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';

const AuthModule = namespace('auth');

@Component({
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Button,
    Loader,
    TextField,
  },
})
export default class PasswordResetView extends Vue {
  @Prop(Object)
  private pagedata!: any;

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @AuthModule.Action('resetPassword')
  public resetPassword!: any;

  public resetIsLoading: boolean = false;

  public errors: ValidationError[] = [];

  public password: string = '';

  public passwordConfirm: string = '';

  public confirmCode: string = '';

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.errors.splice(index, 1);
  }

  public validate(): boolean {
    this.errors = [];
    const validator = new Validator();

    if (validator.isEmpty(this.password)) {
      this.addError('password', 'isEmpty', i18next.t('passwordReset.validation.password.isEmpty'));
    }

    if (validator.isEmpty(this.passwordConfirm)) {
      this.addError('passwordConfirm', 'isEmpty', i18next.t('passwordReset.validation.passwordConfirm.isEmpty'));
    }

    if (this.password !== this.passwordConfirm) {
      this.addError('passwordConfirm', 'isNotSame', i18next.t('passwordReset.validation.passwordConfirm.isNotSame'));
    }

    if (validator.isEmpty(this.confirmCode)) {
      this.addError('confirmCode', 'isEmpty', i18next.t('passwordReset.validation.confirmCode.isEmpty'));
    }

    return this.errors.length === 0;
  }

  public addError(property: string, constraintType: string, message: string): void {
    const errorExisting = this.errors.find(err => err.property === property);
    if (errorExisting) {
      errorExisting.constraints[constraintType] = message;
    } else {
      this.errors.push({
        property,
        constraints: { [constraintType]: message },
        children: [],
      });
    }
  }

  public async submit(): Promise<void> {
    if (!this.validate()) {
      return;
    }

    this.resetIsLoading = true;

    try {
      await this.resetPassword({ password: this.password, code: this.confirmCode });
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          submit: () => {
            this.$router.push({ name: 'login' });
          },
          title: i18next.t('passwordReset.requestSuccess.dialog.title'),
          message: i18next.t('passwordReset.requestSuccess.dialog.body'),
        },
      });
    } catch (e) {
      console.log('Failed to request user password reset', e);

      if (e && e.response && e.response.status === 422) {
        this.errors = e.response.data;
        this.showError(
          i18next.t('passwordReset.requestError.dialog.validation.title'),
          i18next.t('passwordReset.requestError.dialog.validation.body')
        );
      } else {
        this.showError(
          i18next.t('passwordReset.requestError.dialog.unknown.title'),
          i18next.t('passwordReset.requestError.dialog.unknown.body')
        );
      }
    } finally {
      this.resetIsLoading = false;
    }
  }

  public showError(title: string, message: string): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title,
        message,
      },
    });
  }
}
